import {IRPStore} from "../../app/rp_reducer";

export const getAllRegionTypesFromStore = (state: IRPStore) => {
    const regionTypes = state.variables.data?.region_type || [];
    const allRegionTypeValues = regionTypes.map((rt) => rt.value);

    return allRegionTypeValues;
};
import {IRPStore} from "../../app/rp_reducer";

export const getAllRegionTypesFromStore = (state: IRPStore) => {
    const regionTypes = state.variables.data?.region_type || [];
    const allRegionTypeValues = regionTypes.map((rt) => rt.value);

    return allRegionTypeValues;
};
